import axios from 'axios';
import * as CONFIG from '../config/index';
export const DEPARTMENT_API_URL = `${CONFIG.API_URL}/department`
export default {
  getAll: () => {
    return axios.get(`${DEPARTMENT_API_URL}/search?pageNo=1&pageSize=20`);
  },
  getFsubu: () => {
    return axios.get(`${CONFIG.API_URL}/department/getFsubu`);
  },
  sync: {
    getAll: async () => {
      let res = await axios.get(`${DEPARTMENT_API_URL}/search`);
      return res.data.data.items;
    },
    getFsubu: async () => {
      let res = await axios.get(`${CONFIG.API_URL}/department/getFsubu`);
      return res.data.data.items;
    },
    search: async (searchProps) => {
      let props = {
        name: searchProps.name ? searchProps.name : '',
        code: searchProps.code ? searchProps.code : '',
        pageNo: searchProps.pageNo ? searchProps.pageNo : CONFIG.DEFAULT_PAGE_START,
        pageSize: searchProps.pageSize ? searchProps.pageSize : CONFIG.DEFAULT_PAGE_SIZE
      }
      let res = await axios.get(`${CONFIG.API_URL}/department/search?name=${props.name}&code=${props.code}&pageNo=${props.pageNo}&pageSize=${props.pageSize}`);
      return res.data.data;
    },
    getByCode: async (codes) => {
      let strCodes = codes.join();
      let res = await axios.get(`${DEPARTMENT_API_URL}/get-by-code?codes=${strCodes}`);
      return res.data.data ? res.data.data.items : [];
    }
    
  }
}



// WEBPACK FOOTER //
// ./src/common/department.js